import { useEffect } from 'react';
import { Screen } from '@epihub/web/src/routes/Screen';
import { downloadCVRoute } from '@krishanmadan/core/src/routes/frontendRoutes';
import { DownloadCVView } from '@krishanmadan/frontend/src/components/DownloadCV';
import { downloadCVProgrammatically } from '@krishanmadan/frontend/src/lib/downloadCVProgrammatically';

export const CVScreen = Screen(downloadCVRoute, () => {
  useEffect(() => {
    downloadCVProgrammatically();
  }, []);

  return <DownloadCVView />;
});
